<div #canvasContainer style="width: 100% !important; height: 100% !important; position: relative" class="canvas-container">
    <canvas #gameCanvas style="width: 100% !important; height: 100% !important" class="game-canvas"></canvas>
</div>
